module.exports = __webpack_public_path__ + "static/seguridad-f333a07111bffe26dbb05780d4df13e1.png";